import React from "react";
import ModalError from "../components/common/ModalError";
const { useHistory } = require("react-router-dom");
const ErrorContext = React.createContext<{ onError: (err: string) => void }>({
  onError: (_: string) => {},
});

const ErrorModalProvider: React.FC = ({ children }) => {
  const [isShowModelError, setIsShowModelError] =
    React.useState<boolean>(false);
  const [textError, setTextError] = React.useState<string>("");
  const history = useHistory();
  const onError = (error: any) => {
    if (error === undefined) return "มีบางอย่างผิดพลาด";
    if (
      error?.status === 403 ||
      error?.status === "403" ||
      error?.response?.status === 403 ||
      error?.response?.status === "403" ||
      error?.code === "auth/invalid-custom-token" ||
      error?.response?.data?.error?.code === "auth/invalid-custom-token"
    ) {
      localStorage.removeItem("token");
      history.replace("/login");
      return "กรุณาเข้าสู่ระบบใหม่อีกครั้ง";
    }
    setTextError(
      error.response?.data?.error?.message ||
        error.response?.data?.error?.code ||
        error.response?.data?.message ||
        error.message ||
        error
    );
    setIsShowModelError(true);
  };
  return (
    <ErrorContext.Provider value={{ onError }}>
      <ModalError
        showErr={isShowModelError}
        setShowErr={setIsShowModelError}
        error={textError}
      />
      {children}
    </ErrorContext.Provider>
  );
};

export default ErrorModalProvider;

export const useError = () => React.useContext(ErrorContext);
